import * as React from 'react';

export const ForgotPasswordPage = React.lazy(() =>
  import('./ForgotPasswordPage')
);
